import { debounce } from "lodash-es"
import { exoClickBottomPc } from "./templates"
import "./exoclick-style.css"

export const exoClickOnWindowResizeDebounceMs = 200

export function rerenderExoClickPcBottom() {
    if (userData.hasAdFree || !userData.isAgeVerified) {
        return
    }
    const pcExoClick = document.querySelector("#exoclick-bottom")
    if (pcExoClick) {
        pcExoClick.outerHTML = exoClickBottomPc
    }
}

if (!userData.hasAdFree && userData.isAgeVerified) {
    window.addEventListener("orientationchange", debounce(rerenderExoClickPcBottom, exoClickOnWindowResizeDebounceMs))
    window.addEventListener("resize", debounce(rerenderExoClickPcBottom, exoClickOnWindowResizeDebounceMs))
}
